import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './_style.css';

function RoomCard(props) {
  const { resourceSubType, children, onClick } = props;

  return (
    <div
      role="button"
      tabIndex="0"
      className="RoomCard"
      onClick={onClick}
      style={{ borderLeft: `solid 8px ${ resourceSubType.color }` }}>
      {React.Children.map(children, child => {
        if (!child) {
          return null;
        }
        const childClasses = child.props && child.props.className;
        return React.cloneElement(child, {
          className: cx('RoomCard__Section', childClasses)
        });
      })}
    </div>
  );
}

RoomCard.propTypes = {
  resourceSubType: PropTypes.shape(),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onClick: PropTypes.func
};

export default RoomCard;
